module.exports = __webpack_public_path__ + "img/20200915_073934.ba2029f4.jpg";